module.exports = __webpack_public_path__ + "static/media/fbtb_bg_photo.f84ad2d5.png";